import { ChangeEventHandler } from 'react';
import { cn } from '@utils';
import './style.scss';

export interface CommonInputProps {
  value?: string;
  type?: string;
  className?: string;
  placeholder?: string;
  label?: string;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onBlur?: () => void;
  error?: boolean;
  errorMessage?: string | null;
}

export const CommonInput = (props: CommonInputProps) => {
  return (
    <div className={cn('common-input', [props.className || ''])}>
      {
        props.label && (
          <span className="common-input__label text-subtitle-2">{props.label}</span>
        )
      }
      <input
        className={props.error ? 'error' : ''}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        onBlur={props.onBlur}
        type={props.type || 'text'}
      />
      {
        props.error && props.errorMessage && (
          <p className="common-input__error-message text-subtitle-2">
            {props.errorMessage}
          </p>
        )
      }
    </div>
  );
};
